'use strict';

/*
   In Media Shuttle the "contentDelivery" attribute of a portal refers to the portal type.
   
   TEAMSPACES => Share portal
   USER => Send portal
   FOLDER => Submit portal
 */

var contentDeliveryTypes = {
    TEAMSPACES: 'TEAMSPACES',
    USER: 'USER',
    FOLDER: 'FOLDER'
};

module.exports = contentDeliveryTypes;